// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","caption":"_1dJD2pSCq2-UhXWE_3mRfd","borderGrey2":"#e2e2e2","greyBox":"_2W7y_-7Oz6oSYafjBdNRAD _1dJD2pSCq2-UhXWE_3mRfd","addToListButton":"_10tZG7TDdIKkiZTonmgWTJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/action-button-container/ActionButtonContainer.css
// module id = 1023
// module chunks = 1